import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// 2. 引入组件样式
import 'vant/lib/index.css';

createApp(App).use(router).mount('#app')
